const DefaultPalette = (mode, settings) => {
  // ** Core colors from your design
  const whiteColor = '#FFFFFF';
  const lightTextColor = '#2E0F14';  // Set primary text color for light mode
  const darkTextColor = 'rgb(219, 219, 235)';
  const darkPaperBgColor = '#2B2C40';

  const softPink = '#FFD9E033';        // background pink
  const mainRed = '#9E1B32';         // deep red used in buttons and brand
  const sidebarActive = '#FDEBED';  // active menu item background
  const sidebarText = '#6B5B6E';    // nav text

  const mainColor = mode === 'light' ? lightTextColor : darkTextColor;

  const defaultBgColor = () => {
    if (settings.skin === 'bordered' && mode === 'light') {
      return whiteColor;
    } else if (settings.skin === 'bordered' && mode === 'dark') {
      return darkPaperBgColor;
    } else if (mode === 'light') {
      return softPink;
    } else return '#232333';
  };

  const collapseTogglerBgColor = () => {
    if (settings.skin === 'bordered') {
      return settings.mode === 'dark' ? darkPaperBgColor : whiteColor;
    } else {
      return settings.mode === 'dark' ? '#232333' : softPink;
    }
  };

  return {
    customColors: {
      dark: darkTextColor,
      main: mainColor,
      light: lightTextColor,
      lightPaperBg: whiteColor,
      darkPaperBg: darkPaperBgColor,
      collapseTogglerBg: collapseTogglerBgColor(),
      bodyBg: defaultBgColor(),
      trackBg: mode === 'light' ? '#E9E6ED' : '#444463',
      avatarBg: mode === 'light' ? '#F0EFF0' : '#3F3B59',
      tableHeaderBg: mode === 'light' ? '#F8F6F8' : '#353649',
    },
    mode: mode,
    common: {
      black: '#000',
      white: whiteColor,
    },
    primary: {
      light: '#C54157',
      
      main: mainRed,
      dark: '#7A0C20', 
     
      contrastText: whiteColor,
    },
    secondary: {
      light: '#CEB6C2',
      main: '#854752', // <-- your new secondary.main color
      dark: '#4B3F50',
      contrastText: whiteColor,
    },    
    error: {
      light: '#FF5B3F',
      main: '#FF3E1D',
      dark: '#E8381A',
      contrastText: whiteColor,
    },
    warning: {
      light: '#FFD27C',
      main: '#FFB020',
      dark: '#E69700',
      contrastText: whiteColor,
    },
    info: {
      light: '#B9E6FF',
      main: '#4FC3F7',
      dark: '#039BE5',
      contrastText: whiteColor,
    },
    success: {
      light: '#B2F2BB',
      main: '#51C96C',
      dark: '#3CA754',
      contrastText: whiteColor,
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#F5F5F5',
      A200: '#EEEEEE',
      A400: '#BDBDBD',
      A700: '#616161',
    },
    text: {
      primary: `rgba(${mainColor.slice(4, -1)}, 0.87)`,
      secondary: `rgba(${mainColor.slice(4, -1)}, 0.6)`,
      disabled: `rgba(${mainColor.slice(4, -1)}, 0.38)`,
    },
    divider: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
    background: {
      paper: mode === 'light' ? whiteColor : darkPaperBgColor,
      default: defaultBgColor(),
    },
    action: {
      active: `rgba(${mainColor.slice(4, -1)}, 0.54)`,
      hover: `rgba(${mainColor.slice(4, -1)}, 0.04)`,
      selected: `rgba(${mainColor.slice(4, -1)}, 0.08)`,
      disabled: `rgba(${mainColor.slice(4, -1)}, 0.26)`,
      disabledBackground: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
      focus: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
    },
  };
};

export default DefaultPalette;



//here is the old code
// const DefaultPalette = (mode, settings) => {
//   // ** Vars
//   const whiteColor = '#FFF';
//   const lightColor = 'rgb(50, 71, 92)'; // Fixed format
//   const darkColor = 'rgb(219, 219, 235)'; // Fixed format
//   const darkPaperBgColor = '#2B2C40';
//   const mainColor = mode === 'light' ? lightColor : darkColor;

//   const defaultBgColor = () => {
//     if (settings.skin === 'bordered' && mode === 'light') {
//       return whiteColor;
//     } else if (settings.skin === 'bordered' && mode === 'dark') {
//       return darkPaperBgColor;
//     } else if (mode === 'light') {
//       return '#F5F5F9';
//     } else return '#232333';
//   };

//   const collapseTogglerBgColor = () => {
//     if (settings.skin === 'bordered') {
//       return settings.mode === 'dark' ? darkPaperBgColor : whiteColor;
//     } else {
//       return settings.mode === 'dark' ? '#232333' : '#F5F5F9';
//     }
//   };

//   return {
//     customColors: {
//       dark: darkColor,
//       main: mainColor,
//       light: lightColor,
//       lightPaperBg: whiteColor,
//       darkPaperBg: darkPaperBgColor,
//       collapseTogglerBg: collapseTogglerBgColor(),
//       bodyBg: mode === 'light' ? '#F5F5F9' : '#232333',
//       trackBg: mode === 'light' ? '#EBEEF0' : '#444463',
//       avatarBg: mode === 'light' ? '#F0EFF0' : '#3F3B59',
//       tableHeaderBg: mode === 'light' ? '#F3F4F6' : '#353649',
//     },
//     mode: mode,
//     common: {
//       black: '#000',
//       white: whiteColor,
//     },
//     primary: {
//       light: '#9E1B32',
//       main: '#696CFF',
//       dark: '#6062E8',
//       contrastText: whiteColor,
//     },
//     secondary: {
//       light: '#97A2B1',
//       main: '#8592A3',
//       dark: '#798594',
//       contrastText: whiteColor,
//     },
//     error: {
//       light: '#FF5B3F',
//       main: '#FF3E1D',
//       dark: '#E8381A',
//       contrastText: whiteColor,
//     },
//     warning: {
//       light: '#FFB826',
//       main: '#FFAB00',
//       dark: '#E89C00',
//       contrastText: whiteColor,
//     },
//     info: {
//       light: '#29CCEF',
//       main: '#03C3EC',
//       dark: '#03B1D7',
//       contrastText: whiteColor,
//     },
//     success: {
//       light: '#86E255',
//       main: '#71DD37',
//       dark: '#67C932',
//       contrastText: whiteColor,
//     },
//     grey: {
//       50: '#FAFAFA',
//       100: '#F5F5F5',
//       200: '#EEEEEE',
//       300: '#E0E0E0',
//       400: '#BDBDBD',
//       500: '#9E9E9E',
//       600: '#757575',
//       700: '#616161',
//       800: '#424242',
//       900: '#212121',
//       A100: '#F5F5F5',
//       A200: '#EEEEEE',
//       A400: '#BDBDBD',
//       A700: '#616161',
//     },
//     text: {
//       primary: `rgba(${mainColor.slice(4, -1)}, 0.87)`,
//       secondary: `rgba(${mainColor.slice(4, -1)}, 0.6)`,
//       disabled: `rgba(${mainColor.slice(4, -1)}, 0.38)`,
//     },
//     divider: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
//     background: {
//       paper: mode === 'light' ? whiteColor : darkPaperBgColor,
//       default: defaultBgColor(),
//     },
//     action: {
//       active: `rgba(${mainColor.slice(4, -1)}, 0.54)`,
//       hover: `rgba(${mainColor.slice(4, -1)}, 0.04)`,
//       selected: `rgba(${mainColor.slice(4, -1)}, 0.08)`,
//       disabled: `rgba(${mainColor.slice(4, -1)}, 0.26)`,
//       disabledBackground: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
//       focus: `rgba(${mainColor.slice(4, -1)}, 0.12)`,
//     },
//   };
// };

// export default DefaultPalette;

//code2

// const DefaultPalette = (mode, settings) => {
//   // ** Vars
//   const whiteColor = '#FFF'
//   const lightColor = '50, 71, 92'
//   const darkColor = '219, 219, 235'
//   const darkPaperBgColor = '#2B2C40'
//   const mainColor = mode === 'light' ? lightColor : darkColor

//   const defaultBgColor = () => {
//     if (settings.skin === 'bordered' && mode === 'light') {
//       return whiteColor
//     } else if (settings.skin === 'bordered' && mode === 'dark') {
//       return darkPaperBgColor
//     } else if (mode === 'light') {
//       return '#F5F5F9'
//     } else return '#232333'
//   }

//   const collapseTogglerBgColor = () => {
//     if (settings.skin === 'bordered') {
//       if (settings.mode === 'dark') {
//         return darkPaperBgColor
//       } else {
//         return whiteColor
//       }
//     } else {
//       if (settings.mode === 'dark') {
//         return '#232333'
//       } else {
//         return '#F5F5F9'
//       }
//     }
//   }

//   return {
//     customColors: {
//       dark: darkColor,
//       main: mainColor,
//       light: lightColor,
//       lightPaperBg: whiteColor,
//       darkPaperBg: darkPaperBgColor,
//       collapseTogglerBg: collapseTogglerBgColor(),
//       bodyBg: mode === 'light' ? '#F5F5F9' : '#232333',
//       trackBg: mode === 'light' ? '#EBEEF0' : '#444463',
//       avatarBg: mode === 'light' ? '#F0EFF0' : '#3F3B59',
//       tableHeaderBg: mode === 'light' ? '#F3F4F6' : '#353649'
//     },
//     mode: mode,
//     common: {
//       black: '#000',
//       white: whiteColor
//     },
//     primary: {
//       light: '#8082FF',
//       main: '#696CFF',
//       dark: '#6062E8',
//       contrastText: whiteColor
//     },
//     secondary: {
//       light: '#97A2B1',
//       main: '#8592A3',
//       dark: '#798594',
//       contrastText: whiteColor
//     },
//     error: {
//       light: '#FF5B3F',
//       main: '#FF3E1D',
//       dark: '#E8381A',
//       contrastText: whiteColor
//     },
//     warning: {
//       light: '#FFB826',
//       main: '#FFAB00',
//       dark: '#E89C00',
//       contrastText: whiteColor
//     },
//     info: {
//       light: '#29CCEF',
//       main: '#03C3EC',
//       dark: '#03B1D7',
//       contrastText: whiteColor
//     },
//     success: {
//       light: '#86E255',
//       main: '#71DD37',
//       dark: '#67C932',
//       contrastText: whiteColor
//     },
//     grey: {
//       50: '#FAFAFA',
//       100: '#F5F5F5',
//       200: '#EEEEEE',
//       300: '#E0E0E0',
//       400: '#BDBDBD',
//       500: '#9E9E9E',
//       600: '#757575',
//       700: '#616161',
//       800: '#424242',
//       900: '#212121',
//       A100: '#F5F5F5',
//       A200: '#EEEEEE',
//       A400: '#BDBDBD',
//       A700: '#616161'
//     },
//     text: {
//       primary: `rgba(${mainColor}, 0.87)`,
//       secondary: `rgba(${mainColor}, 0.6)`,
//       disabled: `rgba(${mainColor}, 0.38)`
//     },
//     divider: `rgba(${mainColor}, 0.12)`,
//     background: {
//       paper: mode === 'light' ? whiteColor : darkPaperBgColor,
//       default: defaultBgColor()
//     },
//     action: {
//       active: `rgba(${mainColor}, 0.54)`,
//       hover: `rgba(${mainColor}, 0.04)`,
//       selected: `rgba(${mainColor}, 0.08)`,
//       disabled: `rgba(${mainColor}, 0.26)`,
//       disabledBackground: `rgba(${mainColor}, 0.12)`,
//       focus: `rgba(${mainColor}, 0.12)`
//     }
//   }
// }

// export default DefaultPalette
